(function($) {

  $(function() {

    $('#user_login').attr('placeholder', 'E-mail')
    $('#user_pass').attr('placeholder', 'Contraseña')
    $('#wp-submit').attr('value', 'Enter')

    $('#backtoblog').remove()
    $('.privacy-policy-page-link').remove()

    const $nav = $('#login #nav').remove()
    $nav.insertBefore($('#loginform .submit'))

    const $lostpaswordform = $('#lostpasswordform')
    if($lostpaswordform.length) {

      $('#wp-submit').attr('value', 'Send')      
    }

    $('#login').wrapInner('<div class="Wrapper"></div>')
  })

})(jQuery)